import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { CustomValidators } from 'src/app/shared/custom-validators';
import { BaseForm } from 'src/app/shared/product/baseForm';
import { FormValidatorService } from 'src/app/shared/services/form-validator.service';
import { Validators } from 'src/app/shared/validators';

@Component({
  selector: 'app-schedule-repeat-form',
  templateUrl: './schedule-repeat-form.component.html',
  styleUrls: ['./schedule-repeat-form.component.scss'],
})
export class ScheduleRepeatFormComponent
  extends BaseForm
  implements OnInit
{
  today: Date = new Date();
  maxDate: Date = new Date(
    this.today.getFullYear(),
    this.today.getMonth() + 1,
    this.today.getDate()
  );
  displayDateDayFormat = 'DD-MM-YYYY';
  @Input() slectedDateSchedue: Date = null;
  @Input() isDayScheduleValid: boolean;
  public repeatScheduleForm: FormGroup;
  fvRepeatSchedule: FormValidatorService = new FormValidatorService();
  @Output() scheduleRepeatConfirm: EventEmitter<scheduleRepeatFormOutput> =
    new EventEmitter();
  repetionDaysOption = [
    { name: 'Saturday' },
    { name: 'Sunday' },
    { name: 'Monday' },
    { name: 'Tuesday' },
    { name: 'Wednesday' },
    { name: 'Thursday' },
    { name: 'Friday' },
  ];
  repeatUntilObject = {
    fieldName: 'Repeat Untill',
    fieldNameAr: 'تكرار حتى',
    fieldType: 'Date',
    isStaticUI: true,
    defaultValue: '',
    validators: [
      {
        validatorFn: Validators.required,
        message: `${this.validationMsg.required}`,
        messageAr: `${this.validationMsgAr.required}`,
      },
      {
        validatorFn: CustomValidators.dateInTheFuture,
        message: `${this.validationMsg.dateInTheFuture}`,
        messageAr: `${this.validationMsgAr.dateInTheFuture}`,
      },
      {
        validatorFn: CustomValidators.dateMinimum(this.slectedDateSchedue),
        message: `${this.validationMsg.min}`,
        messageAr: `${this.validationMsgAr.min}`,
      },
    ],
  };
  repeatEveryObject = {
    fieldName: 'Repeat Every',
    fieldNameAr: 'تكرار كل',
    fieldType: 'no-label-select-list',
    fieldValues: this.repetionDaysOption,
    defaultValue: '',
    validators: [
      {
        validatorFn: Validators.required,
        message: `${this.validationMsg.required}`,
        messageAr: `${this.validationMsgAr.required}`,
      },
    ],
  };
  isRepeatScheduleObject = {
    fieldName: 'Do you want to repeat the same schedule on other days?',
    fieldNameAr: 'هل تريد تكرار الجدول المحدد لايام اخرى؟',
    fieldType: 'Do you want to repeat the same schedule on other days?',
    isStaticUI: true,
    defaultValue: '',
    validators: [],
  };
  constructor() {
    super();
  }


  controllers = [
    this.repeatUntilObject,
    this.isRepeatScheduleObject,
    this.repeatEveryObject,
  ];
  ngOnInit(): void {
    this.repeatScheduleForm = this.fvRepeatSchedule.createForm(
      this.controllers
    );
  }
  convertControls(name: string) {
    return this.repeatScheduleForm.get(name) as FormControl;
  }
  get isRepeatScheduleControl() {
    return this.repeatScheduleForm.get(
      this.isRepeatScheduleObject.fieldName
    ) as FormControl;
  }
  get reFactoredFormValues(): scheduleRepeatFormOutput {
    const endDate = this.convertControls(
      this.repeatUntilObject.fieldName
    ).value;
    const repeatDays = this.convertControls(
      this.repeatEveryObject.fieldName
    ).value;
    const isRepeatSchedule = this.isRepeatScheduleControl.value;

    return { endDate, repeatDays, isRepeatSchedule };
  }
  onRepeatSchedule() {
    if (
      this.repeatScheduleForm.invalid &&
      this.isRepeatScheduleControl.value == true
    ) {
      this.fvRepeatSchedule.forceShowErrors();
      return;
    }
    this.scheduleRepeatConfirm.emit(this.reFactoredFormValues);
  }
}
export interface scheduleRepeatFormOutput {
  endDate: Date;
  repeatDays: string[];
  isRepeatSchedule: boolean;
}
